<template>
	<div id="pageRoot">

		<p class="textBase appearAnimationB" id="text01" style="z-index: 6">
			Copia aquí el texto corregido.
		</p>

		<span style="outline: 1px solid #a6a6a6; width: 850px; height: 458px; left: 30px; top: 165px; z-index: 2; position: absolute;"></span>
		<saved-input-long v-bind:page="$parent.page" v-bind:type="$parent.type" number=1 id="inputField01" maxlength="250" style="line-height: 74px;"/>

		<div class="pageElement hover-animation-a" id="textBox01">
			<p class="textBase">
				Copia aquí<br>
				el texto corregido.
			</p>
		</div>

		<!-- FONDO SVG ----------------------------------------------------------------------------------------------------->
		<div class="pageElement" id="fixedBackground"></div>
		<span class="footer-page footer-write"></span>
		<!-- FONDO SVG ----------------------------------------------------------------------------------------------------->
	</div>
</template>
<style scoped>
#fixedBackground
{
position: absolute;
width: 829px;
height: 548.05px;
left: 36px;
top: 40.95px;
background-image: url(/pages/img/sordo/svgPage92FixedBackground.svg)
}
#text01
{
position: absolute;
width: 412px;
height: 35px;
left: 78px;
top: 118px;

font-size: 24px;
line-height: 33px;

color: #000000;
}
#textBox01
{
position: absolute;
width: 323.67px;
height: 115.67px;
left: 458px;
top: 606px;
background-image: url(/pages/img/sordo/svgPage92TextBox01.svg);
z-index: 5;
}
#textBox01 p
{
position: absolute;
width: 229px;
height: 85px;
left: 24px;
top: 21px;

font-size: 26px;
line-height: 35px;
text-align: center;

color: #FBF8F8;
}
#inputField01
{
position: absolute;
width: 806px;
height: 450px;
left: 50px;
top: 157px;
font-size: 33px;
z-index: 10;
}
</style>
<script>
export default {
  data() {
    return {
      videos: ["p93/V133.mp4", "p93/V134.mp4", "p93/V135.mp4", "p93/V136.mp4", "p93/V137.mp4"]
    }
  }
}
</script>